export default function (price, currency, texIncluded) {
  let taxDisplay = '+ applicable taxes';
  if (currency !== 'USD' || texIncluded) {
    taxDisplay = 'tax included';
  }
  return price > 0 ? taxDisplay : '';
}
